import { useEffect } from 'react';
import { Routes, Route } from 'react-router';
import MainComponent from '../components/MainComponent/MainComponent';
import { Sample } from '../components/Sample';
import { useDispatch } from 'react-redux';
import {
  isComingFromMainWindow,
  useFindPermissions,
} from '../utils/helpers/useFindPermissions';
import {
  setAuditState,
  setContextId,
  setIsReadOnly,
  setQueryObj,
} from '../redux/reducer/contextIdReducer';
import { setCoreScriptContextId } from '../redux/reducer/coreScriptReducer';
import { Flows } from '../utils/enum_constants/decision';
import usePermissions from '../hooks/usePermissions';
import useQueryObject from '../hooks/useQueryObject';

const AuditRoutes = () => {
const dispatch = useDispatch();
const { hasCoreScriptSave } = useFindPermissions();
const { isContextReadOnly } = useQueryObject();


  useEffect(() => {
    const url = new URL(globalThis.location.href);
    const params = new URLSearchParams(url.search);

    const queryObject: Record<string, string> = {};
    // eslint-disable-next-line unicorn/no-array-for-each
    params.forEach((value, key) => {
      queryObject[key] = value;
    });

    if (url.pathname.slice(1) === Flows?.Audit) {
      dispatch(setAuditState(true));
    } else dispatch(setAuditState(false));

    const isReadOnly =
      (Object.prototype.hasOwnProperty.call(queryObject, 'r') &&
        queryObject['r'] === Flows?.Read_Only) || isContextReadOnly ||
      (isComingFromMainWindow() && !hasCoreScriptSave);



    dispatch(setIsReadOnly(isReadOnly));
    dispatch(setQueryObj(queryObject));
    dispatch(setCoreScriptContextId(queryObject?.id));
    dispatch(setContextId(queryObject?.id));
  }, [isContextReadOnly, hasCoreScriptSave, dispatch]);


  return (
    <Routes>
      <Route path='/' element={<MainComponent />} />
      <Route path='/audit' element={<MainComponent />} />
      <Route path='/nonaudit' element={<MainComponent />} />
      <Route path='/sample' element={<Sample />} />
    </Routes>
  );
};

export default AuditRoutes;
